module.exports = __webpack_public_path__ + "img/resources-768.bc4a70b2.jpg";